export const GRP_BASEURL_PRELIVE = "https://grp-prelive.volkswagenag.com";
export const GRP_BASEURL_PROD = "https://grp.volkswagenag.com";

export const GRP_ROLE_ADMIN = 8;

export enum GRP_ROLE {
  RESEAU_21 = 21,
  RESEAU_1 = 1,
  RESEAU_16 = 16,
  RESEAU_17 = 17,
  IT_SUPPORT = 8,
  BONUS_MANAGER = 100750,
}

export const GRP_ROLE_VGF = GRP_ROLE.BONUS_MANAGER;

export const GRP_ROLES = {
  RESEAU: [
    GRP_ROLE.RESEAU_21,
    GRP_ROLE.RESEAU_1,
    GRP_ROLE.RESEAU_16,
    GRP_ROLE.RESEAU_17,
  ],
  IT_SUPPORT: [GRP_ROLE.IT_SUPPORT],

  BONUS_MANAGER: [GRP_ROLE.BONUS_MANAGER],
  VGF: [GRP_ROLE.BONUS_MANAGER],
} as const;

export const GRP_ROLES_HRIN = [
  ...GRP_ROLES.RESEAU,
  ...GRP_ROLES.IT_SUPPORT,
  ...GRP_ROLES.BONUS_MANAGER,
] as const;

export const GRP_ROLES_KVPS_BYPASS = [
  GRP_ROLE_ADMIN,
  ...GRP_ROLES.IT_SUPPORT,
  ...GRP_ROLES.BONUS_MANAGER,
] as const;

export function hasGrpKvpsBypass(grpRoles: number[]): boolean {
  return grpRoles.some((role) =>
    (GRP_ROLES_KVPS_BYPASS as readonly number[]).includes(role),
  );
}
